import React from 'react';
import Styled from 'styled';

import defaultStyles from './vendor-badge.scss';

interface Props {
    styles: typeof defaultStyles;
}

const badge: React.FC<Props> = props => <span className={props.styles.badge}>PRO</span>;
export default Styled(defaultStyles)(badge);
